import { z } from 'zod';

export const NPS_COMMENT_MAX_LENGTH = 500;

export const npsResponseSchema = z
  .object({
    score: z.number().int().min(1).max(10),
    comment: z
      .string()
      .max(
        NPS_COMMENT_MAX_LENGTH,
        `O comentário deve ter até ${NPS_COMMENT_MAX_LENGTH} caracteres.`,
      ),
  })
  .superRefine(({ comment, score }, context) => {
    if (score <= 8 && comment.trim().length === 0) {
      context.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['comment'],
        message: 'Conte um pouco mais sobre sua experiência para continuar.',
      });
    }
  });

export type NpsResponseFormData = z.infer<typeof npsResponseSchema>;
